// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const ObjectsColumnOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 448 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M48 80v160h96V80H48zM0 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zm304 192v160h96V272h-96zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V272zm-112 96H48v64h96v-64zm-96-48h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48zM304 80v64h96V80h-96zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V80z"}}]},"name":"objects-column","theme":"outlined"};

const ObjectsColumnOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={ObjectsColumnOutlinedSvg} />;
  ObjectsColumnOutlined.displayName = 'ObjectsColumnOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(ObjectsColumnOutlined);
